import i18next from 'i18next'
import { FormInput, FormSelectA11y, IconFa, SingleOption, Text } from '../../atoms'

export interface FilterSearchProps {
  searchPhrase: string
  setSearchPhrase: (value: string) => void
  filterOptions: SingleOption[]
  setFilterOption: (code: string | number) => void
  selectedFilterOption: string | number
  label?: string
  inputPlaceholder?: string
}

export const FilterSearch = ({
  searchPhrase,
  setSearchPhrase,
  filterOptions,
  setFilterOption,
  selectedFilterOption,
  label,
  inputPlaceholder
}: FilterSearchProps) => {
  return (
    <fieldset className="w-full">
      <Text as="legend" textType="xs">
        {label ?? i18next.t('glow.filter')}
      </Text>
      <div className="flex">
        <FormSelectA11y
          className="w-41"
          buttonClass="rounded-r-none"
          aria-label={i18next.t('glow.filter')}
          showNoneOption={false}
          selected={filterOptions.find((x) => x.code === selectedFilterOption)?.code}
          options={filterOptions}
          onSelect={(code) => setFilterOption(code as string | number)}
        />
        <FormInput
          value={searchPhrase}
          type="search"
          aria-label={i18next.t('glow.search')}
          onClear={() => setSearchPhrase('')}
          onChange={(event) => setSearchPhrase((event.target as HTMLInputElement).value)}
          className="min-w-[300px] self-end [&>div>input]:rounded-l-none"
          icon={<IconFa icon={['far', 'magnifying-glass']} />}
          placeholder={(inputPlaceholder ?? i18next.t('glow.search')) + '...'}
        />
      </div>
    </fieldset>
  )
}
